import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { InteractiveText, SecondaryText, Theme } from "@silvertours/front-shared";
var layout = function() {
    return /*#__PURE__*/ css("width:100%;max-width:500px;display:flex;flex-direction:column;align-items:center;", Theme.mq("lg"), "{margin-left:1.5rem;margin-right:1.5rem;max-width:none;}> *{width:100%;}");
};
var Anchor = /*#__PURE__*/ styled("a", {
    target: "eqbpjxt0"
})("color:inherit;text-decoration:inherit;");
var OpeningTimesWrapper = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt1"
})("display:flex;flex-direction:column;align-items:center;");
var InfoWrapper = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt2"
})(layout(), ";padding-left:1rem;padding-right:1rem;row-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var InteractivePhoneNumber = /*#__PURE__*/ styled(InteractiveText, {
    target: "eqbpjxt3"
})("margin-top:1.5rem;text-align:center;font-size:24px;", Theme.mq("lg"), "{margin-top:1rem;}");
var OpeningHours = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt4"
})("padding-bottom:", function(param) {
    var showVoucherInfo = param.showVoucherInfo;
    return !showVoucherInfo && "2rem";
}, ";max-width:222px;align-self:center;");
var Information = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt5"
})("margin-top:0.5rem;");
var ScheduleRow = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt6"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";font-weight:", function(param) {
    var type = param.type;
    return type === "common" && "bold";
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.size;
}, ";display:grid;grid-template-columns:minmax(0,1fr) max-content;");
var Footer = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt7"
})(layout(), ";background-color:#f5f5f5;margin-top:2.5rem;padding:1.5rem 1rem;", Theme.mq("lg"), "{margin-top:2rem;}");
var VoucherWrapper = /*#__PURE__*/ styled("div", {
    target: "eqbpjxt8"
})("text-align:center;max-width:500px;");
var VoucherText = /*#__PURE__*/ styled(SecondaryText, {
    target: "eqbpjxt9"
})("margin-top:1rem;");
export { Anchor, Footer, Information, InfoWrapper, InteractivePhoneNumber, OpeningHours, OpeningTimesWrapper, ScheduleRow, VoucherText, VoucherWrapper };
